var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "v-container",
        { staticClass: "grey lighten-4", attrs: { fluid: "", "pa-0": "" } },
        [
          _c(
            "v-row",
            { staticStyle: {}, attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "align-self-center",
                  attrs: { md: "auto", xs: "auto", sm: "auto" }
                },
                [
                  _c("crud-button", {
                    attrs: {
                      "x-large": "",
                      color: "blue-grey darken-1",
                      icon: "fa-chevron-left",
                      tooltip: _vm.$t("global.crud.buttons.return")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.back()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass:
                    "flex-grow-1 flex-shrink-0 container-data-filter-info",
                  attrs: { cols: "1" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "pa-0": "" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { sm: "12", cols: "12" } }, [
                            _c("div", { staticClass: "form-field-name" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("productsTypesRelations.productType")
                                  ) +
                                  " "
                              )
                            ]),
                            _c("div", { staticClass: "form-field-value" }, [
                              _vm._v(" " + _vm._s(_vm.productType) + " ")
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { id: "dataContainer" } },
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.items,
              options: _vm.options,
              page: _vm.pagination.page,
              "server-items-length": _vm.pagination.totalItems - 1,
              "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
              "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
              "footer-props": {
                "items-per-page-options": _vm.rowsPerPageItems,
                "show-first-last-page": true,
                "show-current-page": true
              },
              loading: _vm.loading,
              light: "",
              "multi-sort": "",
              dense: ""
            },
            on: {
              "update:options": function($event) {
                _vm.options = $event
              },
              "update:page": function($event) {
                return _vm.$set(_vm.pagination, "page", $event)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function(ref) {
                  var items = ref.items
                  return [
                    _c(
                      "tbody",
                      _vm._l(items, function(item) {
                        return _c("tr", { key: item.code }, [
                          _c("td", [
                            _vm._v(
                              _vm._s(item.code) + " - " + _vm._s(item.name)
                            )
                          ]),
                          _c(
                            "td",
                            [
                              _c(
                                "v-btn-toggle",
                                {
                                  attrs: { rounded: "" },
                                  on: {
                                    change: function($event) {
                                      return _vm.manageButtons(item)
                                    }
                                  },
                                  model: {
                                    value: item.relation,
                                    callback: function($$v) {
                                      _vm.$set(item, "relation", $$v)
                                    },
                                    expression: "item.relation"
                                  }
                                },
                                [
                                  _c("v-btn", { attrs: { value: "D" } }, [
                                    _vm._v(" " + _vm._s(_vm.buttonD) + " ")
                                  ]),
                                  _c("v-btn", { attrs: { value: "I" } }, [
                                    _vm._v(" " + _vm._s(_vm.buttonI) + " ")
                                  ]),
                                  _c("v-btn", { attrs: { value: "C" } }, [
                                    _vm._v(" " + _vm._s(_vm.buttonC) + " ")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      }),
                      0
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }